exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#progres-rectangle{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999;max-height:100vh;pointer-events:none}#progres-rectangle #rect-path{stroke-dasharray:calc(2 * 100vw + 2* 100vh);stroke-dashoffset:calc(2 * 100vw + 2* 100vh)}", ""]);

